import * as React from "react";
import Alert from "@mui/material/Alert";
import { AlertTitle, Typography, Box, Container } from "@mui/material";
import WarningSharpIcon from "@mui/icons-material/WarningSharp";
import SuccessIcon from "./SuccessIcon";

let colors = {};

/**
 *
 * @param {*} param0
 * @returns
 */

export default function ActionAlert({ title, children, onClose, type, sx, ...rest }) {
  let actionIcon = null;

  if (type === "error") {
    colors = {
      bgcolor: "alert.lightRed",
      color: "warning.main",
    };
    actionIcon = (
      <Box sx={styles.icon}>
        <WarningSharpIcon sx={{ color: "#FFFFFF" }} />
      </Box>
    );
  } else if (type === "success") {
    colors = {
      bgcolor: "#766f46",
      color: "green",
    };
  } else if (type === "info") {
    colors = {
      bgcolor: "#EADDFF40",
      color: "primary.main",
    };
    actionIcon = <SuccessIcon />;
  } else {
    colors = {
      bgcolor: "#FFF0E2",
      color: "#E1A836",
    };
    actionIcon = (
      <Box sx={{ ...styles.icon, bgcolor: "#E1A836" }}>
        <WarningSharpIcon sx={{ color: "#FFFFFF" }} />
      </Box>
    );
  }

  return (
    <Box sx={{ bgcolor: colors.bgcolor, width: "100%" }}>
      <Container maxWidth="xl" sx={{ padding: { lg: "0rem 4rem", md: "0.3rem 2rem", xs: "0.3rem 1rem" }, textAlign: "left" }}>
        <Alert
          icon={
            <>
              {actionIcon}

              <Typography
                sx={{
                  color: colors.color,
                  display: { sm: "none", xs: "block" },
                }}
              >
                {title}
              </Typography>
            </>
          }
          sx={[{ ...styles.alert, ...sx }]}
          onClose={onClose}
          {...rest}
        >
          <AlertTitle
            sx={{
              display: { sm: "block", xs: "none" },
              color: colors.color,
              fontSize: { lg: "1rem", md: "1.125rem", xs: "1rem", sm: "1rem" },
            }}
          >
            {title}
          </AlertTitle>
          <Typography sx={{ fontSize: { xs: "0.875rem", lg: "0.875rem" } }}>{children}</Typography>
        </Alert>
      </Container>
    </Box>
  );
}

const styles = {
  alert: {
    bgcolor: "transparent",
    borderRadius: { lg: "8px", xs: 0 },
    flexWrap: { sm: "nowrap", xs: "nowrap" },
    alignItems: "center",
    justifyContent: "center",
    px: 0,
    "&	.MuiAlert-message": {
      order: { sm: 2, xs: 2 },
      width: { sm: "auto", xs: "75%" },
    },
    "& .MuiAlert-icon": {
      order: { sm: 1, xs: 1 },
      width: { sm: "auto", xs: "auto" },
      pr: { lg: "2%", md: "1%" },
      justifyContent: "center",
      alignItems: "center",
    },
    "& .MuiAlert-action": {
      order: { md: 3, xs: 3, sm: 3 },
      width: "auto",
      alignSelf: { lg: "center", xs: "center", sm: "center" },
    },
  },
  icon: {
    bgcolor: "#D65A26",
    color: colors.color,
    borderRadius: 50,
    width: "2.5rem",
    height: "2.5rem",
    // padding: "0.5rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};
